module.exports = __webpack_public_path__ + "app/components/devices/message-board/schedule.view.html";